module.exports = __webpack_public_path__ + "static/media/email-icon.967e73f1.svg";